// libs
import React, { memo, useState } from 'react';
import dayjs from 'dayjs';
import cx from 'classnames';
// dls
import { Text } from '@swiggy-private/dls-web-core/dist/components/Text';
import { Svg12 as ArrowDown } from '@swiggy-private/dls-web-icons/dist/web/generic/chevronDown';
import { GenericIcon } from '@swiggy-private/dls-web-icons/dist/GenericIconWeb';
// widgets
import { InfoFooter } from '@/widgets/InfoFooter';
// constants
import { DlsColorTokens, DlsFontVariants } from '@/constants/DLSTokens';
// styles
import styles from './ActionButton.module.scss';
function ActionButton({ openMenu, value, placeholder, disabled, errorMsg, className, }) {
    const [focused, setFocused] = useState(false);
    const handleFocus = () => {
        setFocused(true);
    };
    const handleBlur = () => {
        setFocused(false);
    };
    const renderErrorMessage = () => {
        return (React.createElement(Text, { variant: DlsFontVariants.body_B3_Med, color: DlsColorTokens.negative }, errorMsg));
    };
    return (React.createElement(InfoFooter, { footerClassName: styles.errorFooter, showInfo: !!errorMsg, renderInfo: renderErrorMessage },
        React.createElement("button", { onClick: openMenu, className: cx(styles.trigger, className, {
                [styles.triggerFocused]: focused,
                [styles.triggerFocusedError]: !!errorMsg,
                [styles.triggerDisabled]: disabled,
            }), onFocus: handleFocus, onBlur: handleBlur, disabled: disabled },
            React.createElement(Text, { variant: DlsFontVariants.body_B1_Med, color: DlsColorTokens.text_Highest_Emphasis }, value
                ? dayjs(value).format('DD/MM/YYYY')
                : placeholder !== null && placeholder !== void 0 ? placeholder : 'Select Date'),
            React.createElement(GenericIcon, { Icon: ArrowDown, fillColor: DlsColorTokens.text_Low_Emphasis }))));
}
export default memo(ActionButton);
